<template>
    <div>
        <div class="pageName">商品详情</div>
        <div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="基本信息" name="true">
                    <div class="basic">
                        <div class="img-d">
                            <img :src="goodsDetails.pictureUrl" alt="商品图片">
                        </div>
                        <div class="list-d">
                            <div>商品来源：<span>{{ goodsDetails.goodsType }}</span></div>
                            <div>添加事件：<span>{{ goodsDetails.createTime }}</span></div>
                            <div>商品编号：<span>{{ goodsDetails.goodsCode }}</span></div>
                            <div>商品名称：<span>{{ goodsDetails.goodsName }}</span></div>
                            <div>商品分类：<span>{{ categoryName }}</span></div>
                            <!-- <div class="list-d-h">
                            身高/尺码：
                            <div>
                                <div v-for="goodsDetails."></div>
                            </div>
                        </div> -->
                        </div>
                    </div>
                    <div class="details">
                        <div class="details-a">
                            <span>商品详情</span>
                        </div>
                        <div class="details-b">
                            {{ goodsDetails.goodsAttribute }}
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="已关联的学校" name="false">
                    <el-table ref="schoolList" :data="schoolList" highlight-current-row
                        style="width: 100%"  border  header-align="center">
                        <el-table-column type="index" width="50" label="序号" align="center">
                        </el-table-column>
                        <el-table-column property="schoolName" label="学校名称" align="center">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import request from '../utils/request';
export default {
    data() {
        return {
            goods: {
                goodsId: ''
            },
            activeName: 'true',
            goodsDetails: {},
            categoryName: '',
            schoolList: []
        }
    },
    created() {
        //console.log(1);
        //console.log("params", this.$route.params);
        let res = this.$route.params
        this.goods.goodsId = res && res.id
        this.getGoods()
    },
    methods: {
        //查询商品
        async getGoods() {
            const res = await request({
                method: "POST",
                url: `admin/commodity/warehouse/commodityDetails?goodsId=${this.goods.goodsId}`,
                // data: this.goods
            })
            //console.log("查询商品", res);
            if (res.code === '200') {
                this.goodsDetails = res.data
                this.schoolList = res.data && res.data.schoolList
                this.getClass(res.data)
            } else {
                this.$message.error(res.message)
            }
        },
        handleClick() {
            // //console.log(tab, event);
        },
        //商品品类查询
        async getClass(data) {
            const res = await request({
                method: "POST",
                url: "admin/category/tree",
            })
            //console.log(res);
            if (res.code === '200') {
                res.data.forEach((v) => {
                    v.childList.forEach((h) => {
                        if (h.id === data.categoryId) {
                            //console.log('h', h.id, v.categoryName + '/' + h.categoryName);
                            this.categoryName = v.categoryName + '/' + h.categoryName
                        }
                    })
                    // if(data.categoryName === v.categoryName){
                    //     //console.log('v',v);
                    //     v.childList.forEach((h) => {
                    //         //console.log(h.id);
                    //         if(h.id === data.categoryId){
                    //             //console.log('h',h);
                    //         }
                    //     })
                    // }
                })
            } else {
                this.$message.error(res.message)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.pageName {
    background-color: #F5F5F5;
    height: 50px;
    width: calc(100% + 20px);
    position: relative;
    top: -10px;
    left: -10px;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
}

.basic {
    display: flex;

    .img-d {
        width: 300px;
        height: 300px;
        margin-right: 20px;

        img {
            width: 100%;
            height: 300px;
        }
    }

    .list-d {
        text-align: left;
        padding-left: 20px;

        div {
            margin-bottom: 20px;
        }

        .list-d-h {
            border: 1px solid pink;
            display: flex;
            padding: 10px;
            position: relative;
            left: -10px;
            background-color: #f5f5f5;
            width: 300px;

            div {
                display: flex;
                flex-wrap: wrap;

                span {
                    font-size: 15px;
                }

                div {
                    border: 1px solid greenyellow;
                    height: 24px;
                    width: 30px;
                }
            }

        }
    }
}

.details {
    margin-top: 20px;
    text-align: left;

    .details-a {
        height: 30px;
        line-height: 30px;
        color: #fff;
        border-bottom: 1px solid #017AF6;
        background-color: #F7F7F7;

        span {
            display: inline-block;
            background-color: #017AF6;
            height: 30px;
            padding: 0 10px;
        }
    }

    .details-b {
        background-color: #fff;
        height: 380px;
        margin-top: 20px;
        padding: 10px;
    }
}
</style>y